import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField, } from 'ngx-intl-tel-input';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiUserService } from '../../../core/service/api-user.service';
import { UserValidationService } from '../../../core/service/validations/user-validation.service';
import { RegisterModal } from '../../../core/modal/register-modal';
import { ApiAuthService } from 'src/app/features/auth/core/service/api-auth.service';
import { CountriesModal } from 'src/app/features/auth/core/modals/countries-modal';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleModal } from '../../../core/modal/role-modal';
import { ProfileModal } from '../../../core/modal/profile-modal';
import { HomeService } from 'src/app/features/bidders/core/service/home.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html'
})
export class CreateComponent {
  formSubmitAttempt = false;
  registerForm: FormGroup;
  countries: CountriesModal[] | undefined;
  registerModal: RegisterModal | undefined;
  roleList: RoleModal[] | undefined;
  hide = true;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO: any = CountryISO.SaudiArabia;
  PhoneNumberFormat = PhoneNumberFormat;
  loading = false;
  adminCanChange = true;
  HideEmailAndPhone: boolean = false
  loadingCountries: boolean = false;
  loadingRegions: boolean = false;
  loadingCategory: boolean = false;
  categoriesList: any
  RegionsList: any
  constructor(
    private userValidation: UserValidationService,
    private fb: FormBuilder,
    private apiUserService: ApiUserService,
    private apiService: ApiAuthService,
    private _config: ConfigService,
    public dialogRef: MatDialogRef<CreateComponent>,
    private homeService: HomeService,
    @Inject(MAT_DIALOG_DATA) public data: ProfileModal
  ) {

    if (data?.user) {

      this.onLoadRegion(data?.user?.country_id)
      this.registerForm = this.fb.group(this.userValidation.registerFormValidation(data.user))
    } else {
      this.registerForm = this.fb.group(this.userValidation.registerFormValidation())
    }

  }
  ngOnInit(): void {
    console.log(this.data);

    this.onGetAllCountries();
    this.Getcategories();
    if (this.adminCanChange && this._config._router.url != "/myProfile")
      this.onGetAllRoles();

    // if (this.data?.user) {

    // }

    if (this.data?.type != 'add') {
      this.adminCanChange = this._config.getAuthUserInfo().user.id == this.data?.user?.id ? false : true;
      // this.setFormValues();
      this.removeEmailFrom_Form();
      this.CountryISO = this.data?.user?.phone_code.toLowerCase();

    }
    this.registerForm.valueChanges.subscribe(data => {
      this.formSubmitAttempt = false;
    })

  }

  // setFormValues() {
  // this.registerForm.setValue({
  //   firstname: this.data?.user?.firstname,
  //   lastname: this.data?.user?.lastname,
  //   email: this.data?.user?.email,
  //   phone: this.data?.user?.phone,
  //   national_number: this.data?.user?.national_number,
  //   role: this.data?.user?.roles[0].role_code,
  //   resident_number: this.data?.user?.resident_number,
  //   is_national_number: this.data?.user?.is_national_number,
  //   country: this.data?.user?.country || 1,
  //   region: this.data?.user?.region,
  //   city: this.data?.user?.city,
  //   street_name: this.data?.user?.street_name,
  // });
  // }


  onGetAllCountries() {
    this.loadingCountries = true;
    this.apiService.GetAllCountries().subscribe({
      next: (data: any) => {
        this.loadingCountries = false;
        this.countries = data.data;
      }, error: (error: any) => {
        this.loadingCountries = false;
        this._config.showErrors(error);

      }
    });
  }


  Getcategories() {
    this.loadingCategory = true;
    this.homeService.getCategories().subscribe(
      response => {
        this.loadingCategory = false;
        this.categoriesList = response.data.list
      },
      error => {
        this.loadingCategory = false;
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

      }
    )
  }

  onGetAllRoles() {

    this.apiUserService.onGetAllRoles().subscribe({
      next: (data: any) => {
        this.roleList = data.data.list;

      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

      }
    });

  }

  onLoadRegion(countryId: any) {
    this.loadingRegions = true;
    this.apiService.GetAllRegions(countryId).subscribe({
      next: (res: any) => {
        this.loadingRegions = false;
        this.RegionsList = res.data
      },
      error: (error: any) => {
        this.loadingRegions = false;
        this._config.showErrors(error);
      }
    })
  }

  onRegisterSubmit() {
    console.log(this.registerForm);
    this.formSubmitAttempt = true;
    if (this.registerForm.invalid) {
      return;
    }
    this.loading = true;

    this.registerModal = {
      firstname: this.registerForm.value['firstname'],
      lastname: this.registerForm.value['lastname'],
      email: this.registerForm.value['email'],
      password: this.registerForm.value['password'],
      phone: this.registerForm.value['phone']?.number?.replaceAll(/\s/g, ''),
      phone_code: this.registerForm.value['phone']?.countryCode,
      role: this.registerForm.value['role'],
      national_number: this.registerForm.value['national_number'],
      resident_number: this.registerForm.value['resident_number'],
      is_national_number: this.registerForm.value['is_national_number'],
      country_id: this.registerForm.value['country_id'],
      region_id: this.registerForm.value['region_id'],
      city: this.registerForm.value['city'],
      street: this.registerForm.value['street'],
      interests: this.registerForm.value['interests']
    };
    if (this.registerModal.is_national_number) {
      delete this.registerModal['resident_number']
    } else {
      delete this.registerModal['national_number']
    }


    if (!this.data.user) {
      this.addNewUser(this.registerModal);
    } else {
      this.EditNewUser(this.data?.user?.id, this.registerModal);
    }


  }

  addNewUser(registerModal: any) {
    this.apiUserService.register(registerModal).subscribe({
      next: (data: any) => {
        this.loading = false;
        this._config.toastrService.success(this._config.translate.instant('users.createdSuccessfully'));
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

        this.loading = false;
      }
    })
  }

  EditNewUser(id: string, registerModal: any) {
    this.apiUserService.EditUser(id, registerModal).subscribe({
      next: (data: any) => {
        this.loading = false;
        this._config.toastrService.success(this._config.translate.instant('users.updateSuccessfully'));
        this.dialogRef.close('success');
      }, error: (error: any) => {
        this._config.showErrors(error);

        this.loading = false;
      }
    })
  }
  hasError(controlName: string, errorName: string) {
    return this.registerForm.controls[controlName]?.hasError(errorName);
  }

  removeEmailFrom_Form() {
    // this.registerForm.removeControl('email')
    this.HideEmailAndPhone = true
  }
}
